import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Select } from 'antd';
import MyCompanyService from '../../services/MyCompany.service';
import DataInventoryService from '../../services/DataInventory.service';
import CategoryList from './CategoryList';
import CategoryDetail from './CategoryDetail';
import CookieManagementService from '../../services/CookieManagement.service';
import styled from 'styled-components';

const StyledSelect = styled(Select)`
    .ant-select-selector {
        border: 1px solid #fff !important;
        background: #fff !important;
        border-radius: 6px !important;
    }
`;

export default function CookieCategory() {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [domainList, setDomainList] = useState([]);
    const [domainSelect, setDomainSelect] = useState([]);
    const { Option } = Select;
    const [company, setCompany] = useState([]);
    const [selectCategory, setSelectCategory] = useState();
    const [allCategoryList, setAllCategoryList] = useState();
    const [categoryList, setCategoryList] = useState();
    const [cookieList, setCookieList] = useState();
    const [loadingStatus, setLoadingStatus] = useState();

    const onCompanyChange = async (value) => {
        form.setFieldsValue({
            Company: value,
            Domain: '',
        });
        await getDomainList(value);
    };

    const onDomainChange = async (value) => {
        if (value) {
            let company = findCompany(domainList, value).companyId;
            setDomainSelect({
                domainId: value,
                companyId: company,
                domainName: findCompany(domainList, value).domainName,
            });
            await getCookieCategoryList(company, value);
        }
    };

    const findCompany = (array, domainId) => {
        return array.find((element) => {
            return element.domainId === domainId;
        });
    };
    const getCompanyList = async () => {
        try {
            const { data } = await DataInventoryService.getCompanyList();
            const item = data?.resultData;
            setCompany(item || []);
            form.setFieldsValue({ Company: item[0]?.id });
            await getDomainList(item[0]?.id);
        } catch (err) {
            console.log(err);
        }
    };

    const getDomainList = async (companyId) => {
        let ObjectSearch = {};
        ObjectSearch = {
            companyId: companyId,
            p: 1,
            ps: 10000,
            s: 'domainName',
            sd: 'ASC',
        };
        try {
            const { data } = await MyCompanyService.getDomainList(ObjectSearch);
            const item = data?.resultData;
            setDomainList(item?.result);
            form.setFieldsValue({ Domain: item?.result[0]?.domainId });
            setDomainSelect({
                domainId: item?.result[0]?.domainId,
                companyId: item?.result[0]?.companyId,
                domainName: item?.result[0]?.domainName,
            });
            await getCookieCategoryList(
                item?.result[0]?.companyId,
                item?.result[0]?.domainId
            );
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getCompanyList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCookieCategoryList = async (companyId, domainId) => {
        try {
            const { data } =
                await CookieManagementService.getCookieCategoryList({
                    domainId,
                    companyId,
                });
            if (data?.resultData) {
                setLoadingStatus(true);
                setCookieList();
                const item = data?.resultData;
                const general = item?.general;
                const unclassify = item?.unclassify;
                setAllCategoryList(general.concat(unclassify));
                await setCategoryList(item);
                await setSelectCategory(general[0]);
            }
        } catch (err) {
            setCategoryList([]);
            setSelectCategory([]);
            setCookieList([]);
            setLoadingStatus(false);
            console.log(err);
        }
    };

    const getCategoryDetail = async () => {
        try {
            const { data } = await CookieManagementService.getCategoryDetail({
                cookieCategoryId: selectCategory?.cookieCategoryId,
                s: 'cookieName',
                sd: 'ASC',
            });
            if (data?.resultData) {
                setCookieList(data?.resultData);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        if (selectCategory?.cookieCategoryId) {
            getCategoryDetail();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectCategory]);

    return (
        <>
            <div className="title ">{t('common.CookieCategory')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.CookieManagement')} /
                </span>
                <span> {t('common.CookieCategory')} </span>
            </div>

            <div className="grid grid-cols-4 gap-3 mt-4">
                <div className="p-6 bg-white rounded-md overflow-auto h-[44rem]">
                    <div className="p-6 bg-[#EDEEF9] rounded-md w-[100%] space-y-3 h-48">
                        <Form form={form} layout="vertical">
                            <div className="text-[#65707A] text-[12px] font-semibold ">
                                {t('COOKIE.Company')}
                            </div>
                            <Form.Item className="initial" name="Company">
                                <StyledSelect
                                    size="large"
                                    className="w-[100%] text-left"
                                    placeholder={t(
                                        'COOKIE.PleaseSelectCompany'
                                    )}
                                    onChange={onCompanyChange}
                                >
                                    {company?.map((e) => (
                                        <Option
                                            size="large"
                                            key={e?.id}
                                            value={e?.id}
                                            className="bg-white"
                                            style={{
                                                backgroundColor:
                                                    'white !important',
                                            }}
                                        >
                                            {e?.companyName}
                                        </Option>
                                    ))}
                                </StyledSelect>
                            </Form.Item>
                            <div className="text-[#65707A] text-[12px] font-semibold ">
                                {t('Domain')}
                            </div>
                            <Form.Item className="initial" name="Domain">
                                <StyledSelect
                                    size="large"
                                    className="w-[100%] text-left "
                                    placeholder={t('COOKIE.PleaseSelectDomain')}
                                    onChange={onDomainChange}
                                >
                                    {domainList?.map((e) => (
                                        <Option
                                            size="large"
                                            key={e?.domainId}
                                            value={e?.domainId}
                                        >
                                            {e?.domainName}
                                        </Option>
                                    ))}
                                </StyledSelect>
                            </Form.Item>
                        </Form>
                    </div>
                    <CategoryList
                        categoryList={categoryList}
                        setCategoryList={setCategoryList}
                        setSelectCategory={setSelectCategory}
                        selectCategory={selectCategory}
                        domainList={domainList}
                        domainSelect={domainSelect}
                        getCookieCategoryList={getCookieCategoryList}
                        loadingStatus={loadingStatus}
                    />
                </div>
                <div className="p-6 bg-white rounded-md col-span-3">
                    <CategoryDetail
                        categoryList={allCategoryList}
                        selectCategory={selectCategory}
                        domainList={domainList}
                        domainSelect={domainSelect}
                        setCookieList={setCookieList}
                        cookieList={cookieList}
                        getCategoryDetail={getCategoryDetail}
                        setAllCategoryList={setAllCategoryList}
                        setCategoryList={setCategoryList}
                        setSelectCategory={setSelectCategory}
                        loadingStatus={loadingStatus}
                    />
                </div>
            </div>
        </>
    );
}
